<div class="container_wrapper">
  <div class="center_main">
    <app-common-wrapper [pupil]='currentPupil' [individual_data]='individualData'>
    </app-common-wrapper>
    <div class="students_wrapper">
      <div class="students_wrapper-list" *ngIf='currentPupil != undefined'>
        <app-individual-pupil-list
          [pupil]="pupil"
          [currentPupil]="currentPupil"
          [index]="i"
          [isAbsent]="isPupilAbsent(pupil)"
          *ngFor='let pupil of studentClass.students; let i = index'
          (click)='selectPupilClick(pupil)'
        ></app-individual-pupil-list>
      </div>
      <div class="container" *ngIf="isLoading">
        <div class="row">
          <div class="col text-center">
            <mat-progress-spinner
                class="spinner"
                mode="indeterminate">
            </mat-progress-spinner>
          </div>
        </div>
      </div>
      <div class="container" *ngIf="isLoading && isPupilAbsent(currentPupil)">
        <div class="row">
          <div class="col text-center">
            <h4 style="font-weight: bold; color: #495660;">
              Ученик отсутствовал на уроке
            </h4>
          </div>
        </div>
      </div>
      <div class="students_wrapper-data student_info" *ngIf='!isLoading && !isPupilAbsent(currentPupil)'>
        <table class='student_info-results common_table--common-table'>
          <thead class='table_header--common-table'>
          <tr *ngIf="individualData && boxes">
            <th></th>
            <th class="box_level--common-table" *ngFor="let box of boxes;">
                <span class="box_number">
                  box {{ box.title }}
                </span>
              <div class="box_level" [class.is_extra_exercise]="checkBoxForExtraExercise(box)">
                {{ box.level }}
              </div>
            </th>
          </tr>
          <tr>
            <th class="update-rows--common-table right-align">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" 
                    style="height: 16px; margin-bottom: 6px" class="ind_data-edit-rows-cls-3" 
                    (click)="openTableSelectRowsDialog(individualDataModal);">
                    <defs>
                      <style>.ind_data-edit-rows-cls-1{fill:none;}.ind_data-edit-rows-cls-2{fill:#8dceb3;}.ind_data-edit-rows-cls-3:hover{cursor:pointer;}.ind_data-edit-rows-cls-3:hover .ind_data-edit-rows-cls-2{fill:#4fad93;}</style>
                    </defs>
                    <title>Редактировать строки таблицы</title>
                    <g id="Слой_2" data-name="Слой 2">
                      <g id="Слой_8" data-name="Слой 8">
                        <rect class="ind_data-edit-rows-cls-1" width="16" height="16"/>
                        <path class="ind_data-edit-rows-cls-2" d="M12,8v4a2,2,0,0,1-2,2H2V4H9l1-1H1V15h9a3,3,0,0,0,3-3V7Z"/>
                        <path class="ind_data-edit-rows-cls-2" d="M14.81,1.8l-.1-.1a1,1,0,0,0-1.41,0L13,2l1.5,1.5.31-.28A1,1,0,0,0,14.81,1.8Z"/>
                        <polygon class="ind_data-edit-rows-cls-2" points="6.77 8.23 5 11.5 8.27 9.73 7.49 8.95 6.77 8.23 6.77 8.23"/>
                        <polygon class="ind_data-edit-rows-cls-2" points="7.47 7.53 8.22 8.28 8.97 9.03 13.77 4.23 12.27 2.73 7.47 7.53"/>
                      </g>
                    </g>
                  </svg>
                  <ng-template
                    class="modal fade in"
                    data-backdrop="false"
                    #individualDataModal>
                    <div class="modal-body" style="padding: 0">
                      <app-individual-or-summary-data-modal
                      [data]="selectedTableRows"
                      [summaryOrIndividual]="'individual'"
                      (choseTableRows)="choseIndividualDataTableRows($event)"
                      (closeBtnClicked)="closeIndividualDataModal()"
                      ></app-individual-or-summary-data-modal>
                    </div>
                  </ng-template>
                </span>
            </th>
            <th class="box_name--common-table" 
              *ngFor="let box of individualData.boxes;">
              <div class="box_bgr--common-table">
                <div class="box_files--common-table">
                    <span *ngFor="let file of box.files">
                                      {{ file.str_title }}
                    </span>
                </div>
              </div>
            </th>
            <th class='total--common-table'>Всего</th>
          </tr>
          </thead>
          <tbody *ngIf="individualData && boxes">
          <tr *ngFor='let row of selectedTableRows'>
            <td class='right-align table_cell--common-table--bold'
                [ngClass]='{
                    "color-table-errors": row === "errors",
                    "color-table-earned": row === "earned",
                    "color-table-success": row === "success"
                  }'
                *ngIf="row !== 'tasksSolved'"
            >{{getRowName(row)}}
            </td>
            <td class='right-align table_cell--common-table--bold' *ngIf="row === 'tasksSolved'" data-toggle="tooltip"
                title="Количество заданий бокса, решенных верно/неверно данным учеником (старое название - Решено заданий)">
              {{getRowName(row)}}
            </td>

            <td *ngFor="let box of individualData.box_data;" class="table_cell--common-table"
                [ngClass]='{
                    "empty--common-table": isBoxEmpty(row, box),
                    hidden: isPupilAbsent(currentPupil)
                  }'>
              <ng-template #commonModalTemplate>
                <app-common-modal #commonModal="bs-modal" bsModal
                  [box]="box"
                  [student_id]="studentId"
                  (shouldClose)="hideModal($event)"
                ></app-common-modal>
              </ng-template>
              <div *ngIf="row == 'variantsSolved'"
                   (click)="showModal(commonModalTemplate, box.box, currentPupil)"
                   class='no_level--common-table'>{{ getData(box?.formating_data_cards) }}
              </div>
              <div *ngIf="row == 'extra_exercises'"
                  (click)="showModal(commonModalTemplate, box.box, currentPupil)"
                  class='no_level--common-table'
                  [class.extra_exercise_item]="box.extra_exercise"
              >{{ getData(box.extra_exercise?.formating_data_extra_exercises) }}
              </div>
              <div *ngIf="row == 'extra_exercises'"
                  (click)="showModal(commonModalTemplate, box.box, currentPupil)"
                  class='no_level--common-table'
                  [class.extra_exercise_item]="box.extra_exercise"
              >{{ getData(box.extra_exercise?.formating_data_extra_exercises) }}
              </div>
              <div *ngIf="row == 'tasksSolved'"
                   (click)="showModal(commonModalTemplate, box.box, currentPupil)"
                   [ngClass]='{
                       "success_level--common-table": box.box_solved_confidently,
                       "no_level--common-table": !box.box_solved_confidently
                     }'>{{ getData(box?.formating_data_exercises) }}
              </div>
              <div *ngIf="row == 'errors'"
                   class='color-table-errors no_level--common-table'>{{ getData(box?.box_error_percent) }}
              </div>
              <div *ngIf="row == 'solveAmount'"
                   class='no_level--common-table'>{{ getData(box?.total_students_solved_box) }}
              </div>
              <div *ngIf="row == 'earned'"
                   class='color-table-earned no_level--common-table'>{{ getBoxAmountData(box.box_amount_stat) }}
              </div>
              <div *ngIf="row == 'success'"
                   [ngClass]='{
                       "success_level--common-table": box.box_solved_confidently,
                       "no_level--common-table": !box.box_solved_confidently
                     }'></div>
              <div *ngIf="row == 'averageSolveAmount'"
                   class='no_level--common-table'>{{ getData(box?.average_students_solved_box) }}
              </div>
            </td>
            <td class="table_cell--common-table table_cell--common-table--bold empty--common-table">
              <div *ngIf="row == 'variantsSolved' && !!studentStat"
                   class='no_level--common-table'>{{ getData(studentStat?.formating_data_cards_per_lesson) }}
              </div>
              <div *ngIf="row == 'extra_exercises'"
                  class='no_level--common-table'
              >{{ getData(individualData?.lesson_extra_exercise?.formating_data) }}
              </div>
              <div *ngIf="row == 'tasksSolved' && !!studentStat"
                   class='no_level--common-table'>{{ getData(studentStat?.formating_data_exercises_per_lesson) }}
              </div>
              <div *ngIf="row == 'errors'"
                   class='color-table-errors no_level--common-table'>{{ getData(studentStat?.error_percent_per_lesson) }}
              </div>
              <div *ngIf="row == 'solveAmount'"
                   class='no_level--common-table'>{{ getData(individualData?.total_students_solved) }}
              </div>
              <div *ngIf="row == 'earned'"
                   class='color-table-earned no_level--common-table'>{{ getLessonAmountData(studentAmountStat) }}
              </div>
              <div *ngIf="row == 'averageSolveAmount'"
                   class='no_level--common-table'>
                <div *ngIf="individualData.average_students_solved">{{ getData(individualData?.average_students_solved) }}
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class='student_info-errors'>
          <div class='student_info-errors-title'>
            Ошибки:
          </div>
          <div class='student_info-errors-data'>
            <div *ngIf='studentIncorrectExercises && studentIncorrectExercises.length'>
              <div class='student_info-errors-data--item' *ngFor='let group of studentIncorrectExercisesGroup'>
                <app-individual-data-error [studentIncorrectExercisesGroup]='group'></app-individual-data-error>
              </div>
            </div>
            <div *ngIf='studentIncorrectExercises && !studentIncorrectExercises.length'>
              <span>Без ошибок</span>
            </div>
          </div>
        </div>
        <app-individual-data-plots *ngIf="plotLessonsStats?.length > 0 && plotBoxesStats?.length > 0"
            [boxesStats]='plotBoxesStats'
            [lessonsStats]='plotLessonsStats'
            [studentClass]='studentClass'
            [currentPupil]='currentPupil'>
        </app-individual-data-plots>
      </div>
    </div>
    <app-stat-pagination></app-stat-pagination>
  </div>
</div>

